export const SET_CURRENT_APPOINTMENT = 'SET_CURRENT_APPOINTMENT';
